/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import {
  ColumnContainer,
  MainContainer,
  MainText,
  ResImage,
  SubText,
} from "../../helpers/StyledComponents";
import TitleHeader from "../../components/Common/TitleHeader";
import { Button, Divider } from "antd";
// import useResponsive from "../../hooks/useResponsive";

const BigBibleChallenge = () => {
  // const [details, setDetails] = useState({});
  // const { isMobile } = useResponsive();

  // const onChangeDetails = (key, value) => {
  //   setDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [key]: value,
  //   }));
  // };

  return (
    <>
      <MainContainer>
        <ColumnContainer alignItems="center">
          <TitleHeader
            en="BIG BIBLE CHALLENGE"
            th="ผจญภัยไปกับเรื่องราวอันยิ่งใหญ่ในพระคัมภีร์!"
            center
          />
          <Divider />
          <ResImage src="/webImg/BigBible.jpg" maxWidth="350" shadow border />
          <SubText align="center">
            Big Bible Challenge
            เป็นกลยุทธการสอนพระคัมภีร์แบบใหม่ที่น่าตื่นเต้นสำหรับเด็กอายุ 7-12
            ปี
            <br /> Big Bible Challenge จะช่วยให้เด็กๆ สำรวจเรื่องราวในพระคัมภีร์
            100 เรื่อง
            พูดคุยกันเรื่องความเชื่อและเห็นภาพรวมของพระคัมภีร์ไปพร้อมกับคุณ
          </SubText>
          <SubText align="center">
            ใน Big Bible Challenge มีเรื่องราวจากพระคัมภีร์ 100 เรื่อง แบ่งเป็น
            20 ตอน หรือ 20 "ความท้าทาย" แต่ละความท้าทายมีเรื่องราวในพระคัมภีร์ 5
            เรื่อง
            <br /> เด็กๆ สามารถศึกษา Big Bible Challenge ได้ด้วยตัวเอง
            แต่การเรียนรู้ด้วยกันกับโค้ชพระคัมภีร์ก็จะทำให้การผจญภัยไปกับเรื่องราวอันยิ่งใหญ่ของพระเจ้าสนุกสนานยิ่งขึ้น!
            <br />
            คุณสามารถอ่าน ดูภาพ ค้นดูในเว็บนี้
            <a
              href="https://www.thaibigbiblechallenge.com/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              https://www.thaibigbiblechallenge.com/
            </a>
            <br />
            สำรวจเพิ่มเติม ถามคำถาม หาคำตอบ ลองทำดู คุยกับพระเจ้า.... และอื่นๆ
            ได้อีกมากมาย!
          </SubText>
          <a
            href="https://www.thaibigbiblechallenge.com/"
            target="_blank"
            rel="noreferrer"
          >
            <Button type="primary" danger>
              <div>เข้าสู่เว็บไซต์ Thai Big Bible Challenge</div>
            </Button>
          </a>
          <Divider />
          <TitleHeader
            en="BIG BIBLE CHALLENGE"
            th="สั่งซื้อ BIG BIBLE CHALLENGE ได้ที่นี่"
            center
          />
          <MainText mb="15">ราคา 500 บาท / 128 หน้า</MainText>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSd-pv8vYl_mLly22gZmxps3QrXjTZd7oN5yBUII-cPKcNkmrQ/viewform?embedded=true"
            width="100%"
            height="1200"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>

          {/* <Form
            size={"default"}
            style={{ width: `${isMobile ? "auto" : "500px"}` }}
          >
            <Form.Item label={<div>ชื่อ - นามสกุล</div>}>
              <Input
                onChange={(e) => onChangeDetails("name", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>เบอร์โทรศัพท์</div>}>
              <Input
                onChange={(e) => onChangeDetails("phone", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>อีเมล์</div>}>
              <Input
                onChange={(e) => onChangeDetails("email", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>ที่อยู่สำหรับจัดส่ง</div>}>
              <Input.TextArea />
            </Form.Item>
          </Form>
          <Button type="primary">
            <div>สั่งซื้อหนังสือ</div>
          </Button> */}
        </ColumnContainer>
      </MainContainer>
    </>
  );
};

export default BigBibleChallenge;
